import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { toAbsoluteUrl } from '@shared/helpers';
import { AsideMenuItem } from './AsideMenuItem';
import { MENU_ITEMS } from '@constants/navi';
import { getPetSelector, getSubscriptionsSelector } from '@modules/subscriptions/core/selectors';
import { getCustomerSelector } from '@modules/customer/core/selectors';
import { Divider } from '@layout/components/Divider';

export function AsideMenuMain() {
  const intl = useIntl();

  const pet = useSelector(getPetSelector);
  const subscriptions = useSelector(getSubscriptionsSelector);
  const customer = useSelector(getCustomerSelector);

  const filteredMenuItems = MENU_ITEMS.filter((item) => {
    if (item.id === 'subscriptions' && !subscriptions?.length) {
      return false;
    }

    if (item.requiredTags && item.requiredTags.length > 0) {
      const customerTags = customer?.tags || [];
      const hasAllRequiredTags = item.requiredTags.every((tag) => customerTags.includes(tag));
      if (!hasAllRequiredTags) return false;
    }

    if (item.excludedTags && item.excludedTags.length > 0) {
      const customerTags = customer?.tags || [];
      const hasExcludedTag = item.excludedTags.some((tag) => customerTags.includes(tag));
      if (hasExcludedTag) return false;
    }

    return true;
  });

  return (
    <>
      {filteredMenuItems.map((item, index) => {
        // Menu titles already resolve through intl; only this fallback was still a
        // German literal, so an unnamed pet showed "Hund" in every language.
        const values = {
          petName:
            item?.pet && pet?.name ? pet?.name : intl.formatMessage({ id: 'GLOBAL.DOG_FALLBACK' }),
        };
        const isNotLastItem = index < filteredMenuItems.length - 1;

        return (
          <div key={item.id}>
            <AsideMenuItem
              to={item.to}
              title={intl.formatMessage({ id: item.title }, { ...values })}
              icon={toAbsoluteUrl(item.icon)}
              iconActive={toAbsoluteUrl(item.iconActive || item.icon)}
              type={item.type}
              hasDiscountIcon={item.hasDiscountIcon}
            />
            {isNotLastItem && <Divider cssClasses={['divider-primary-light']} />}
          </div>
        );
      })}
    </>
  );
}
